import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import data from "./restaurants.json";
import "./Review.css";

export default function ReviewPage() {
  const { nickname } = useParams();
  const [reviewEntry, setReviewEntry] = useState(null);

  useEffect(() => {
    const found = data.find(r => r.nickname === nickname);
    if (found) {
      const month = found.datemonth.toString().padStart(2, '0');
      const formattedDate = `${month}/${found.dateyear}`;
      setReviewEntry({
        restaurant_name: found.restaurant_name,
        review: found.review,
        date: formattedDate,
        maplink: found.maplink,
        websitelink: found.websitelink,
        michelinlink: found.michelinlink,
        photolink: found.photolink

      });
    }
  }, [nickname]);

  const formatReview = (text) => {
    if (text.includes('Food: ')){
      const split = text.split('Food: ')
      const regularText = split[0]
      const foodList = split[1]
      return <div>{regularText} <br/> Food: {foodList}</div>
    }
    return text
  }

  return (
    <div className="review-container">
      <h1 className="review-title">
        {reviewEntry ? reviewEntry.restaurant_name : "Restaurant Review"}
      </h1>
      {reviewEntry ? (
        <div className="review-card">
          <h2 className="review-restaurant">{reviewEntry.restaurant_name}</h2>
          <p className="review-text">
            {formatReview(reviewEntry.review)} <br />— Alan {reviewEntry.date}
          </p>
          <div className="review-links">
            <a href={reviewEntry.maplink} target="_blank" rel="noopener noreferrer">
              📍 Location
            </a>{" "}
            |{" "}
            <a href={reviewEntry.websitelink} target="_blank" rel="noopener noreferrer">
              🌐 Website
            </a>
            {
              reviewEntry.michelinlink !== "." && (
                <>
                  |{" "}
                  <a href={reviewEntry.michelinlink} target="_blank" rel="noopener noreferrer">
                    🌟 Michelin
                  </a>
                </>
              )
            }
            {
              reviewEntry.photolink && (
                <>
                  |{" "}
                  <a href={reviewEntry.photolink} target="_blank" rel="noopener noreferrer">
                    📷 Photos
                  </a>
                </>
              )
            }
          </div>
        </div>
      ) : (
        <p className="review-text">No review found for this restaurant.</p>
      )}
    </div>
  );
  
}
